<template>
<div>
	<div
		:class="`${component}-action`">
		<div
			class="item"
			v-for="(item, index) in actions"
			:key="index"
			:class="{
				'handle': item.type === 'move' && component === 'element',
				'container-handle': item.type === 'move' && component === 'section',
				'row-handle': item.type === 'move' && component === 'row',
				'col-handle': item.type === 'move' && component === 'column',
			}"
			:data-action="item.type"
			v-tooltip="item.label"
			@click.stop.prevent="handleAction(item.type, node)"
		>
			<i class="material-icons">
				{{ item.icon }}
			</i>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	generateRandomString,
// eslint-disable-next-line
} from '@/lib/helper';
import {
	sectionNames,
	// eslint-disable-next-line
} from '@/lib/statics';

const elActions = [
	{
		type: 'move',
		label: 'Move Element',
		icon: 'open_with',
	},
	{
		type: 'duplicate',
		label: 'Duplicate Element',
		icon: 'content_copy',
	},
	{
		type: 'edit',
		label: 'Edit Element',
		icon: 'edit',
	},
	{
		type: 'delete',
		label: 'Delete Element',
		icon: 'delete_outline',
	},
];

const sectionActions = [
	{
		type: 'move',
		label: 'Move Section',
		icon: 'open_with',
	},
	{
		type: 'add',
		label: 'Add Row',
		icon: 'add_circle',
	},
	{
		type: 'duplicate',
		label: 'Duplicate Section',
		icon: 'content_copy',
	},
	{
		type: 'edit',
		label: 'Edit Section',
		icon: 'edit',
	},
	{
		type: 'delete',
		label: 'Delete Section',
		icon: 'delete_outline',
	},
];

const rowActions = [
	{
		type: 'move',
		label: 'Move Row',
		icon: 'open_with',
	},
	{
		type: 'add',
		label: 'Add Column',
		icon: 'add_circle',
	},
	{
		type: 'duplicate',
		label: 'Duplicate Row',
		icon: 'content_copy',
	},
	{
		type: 'edit',
		label: 'Edit Row',
		icon: 'edit',
	},
	{
		type: 'delete',
		label: 'Delete Row',
		icon: 'delete_outline',
	},
];

const colActions = [
	{
		type: 'edit',
		label: 'Edit Column',
		icon: 'edit',
	},
];

export default {
	name: 'ElementAction',
	props: ['node', 'component'],
	data() {
		return {
			elActions,
			sectionActions,
			rowActions,
			colActions,
		};
	},
	computed: {
		...mapGetters({
			sectionsCount: 'funnels/sectionsCount',
		}),
		actions() {
			let actions = [];
			if (this.component === 'section') {
				actions = this.sectionActions;
			} else if (this.component === 'row') {
				actions = this.rowActions;
			} else if (this.component === 'col') {
				actions = this.colActions;
			} else {
				actions = this.elActions;
			}
			return actions;
		},
		isMaxSection() {
			const sectionNamesCount = sectionNames.length;
			const max = this.sectionsCount >= sectionNamesCount;
			return max;
		},
	},
	methods: {
		handleAction(type, node) {
			if (this.component === 'section' && type === 'add') {
				this.addRow();
			} else if (this.component === 'row' && type === 'add') {
				this.addCol();
			}

			// if (this.component === 'section' && type === 'duplicate' && this.isMaxSection) {
			// 	return;
			// }

			this.$bus.$emit('action-element', type, node);
		},
		addRow() {
			const currentSection = this.node;
			const parentId = currentSection.id;
			const parentKey = currentSection.key;
			const rowId = `row_${generateRandomString()}`;
			const colId = `col_${generateRandomString()}`;
			const newRow = {
				type: 'row',
				class: 'row',
				id: rowId,
				key: rowId,
				parentId,
				parentKey,
				options: {
					paddingTop: 1,
					paddingRight: 1,
					paddingBottom: 1,
					paddingLeft: 1,
					paddingUnit: 'em',
					fontFamily: '',
					fontSize: '',
					textColor: '',
					backgroundColor: '',
					backgroundImageSrc: '',
					backgroundImageRepeat: 'no-repeat',
					backgroundImageSize: 'cover',
					backgroundImagePosition: 'center center',
				},
				children: [
					{
						type: 'col',
						class: 'col dropzone',
						id: colId,
						key: colId,
						parentId,
						parentKey,
						options: {},
						children: [],
					},
				],
			};

			this.node.children.push(newRow);
			this.$bus.$emit('refresh-jquery');
			this.$bus.$emit('node-tree-change', 'row', 'added');
		},
		addCol() {
			// if (this.colLength >= 4) {
			// 	return;
			// }
			const currentCol = this.node.children.length;
			const parentId = this.node.id;
			const parentKey = this.node.key;
			const id = `col_${generateRandomString()}`;
			const newCol = {
				type: 'col',
				class: 'col dropzone',
				id,
				key: id,
				parentId,
				parentKey,
				options: {},
				children: [],
			};

			if (currentCol < 4) {
				this.node.children.push(newCol);
				this.$bus.$emit('refresh-jquery');
				this.$bus.$emit('node-tree-change', 'column', 'added');
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.avoid-clicks {
	pointer-events: none;
}
</style>
